module.exports = __webpack_public_path__ + "static/profile-pic-d8c91d1c51fcc3f90653a5c287e6142a.jpeg";